const wallBiensVendus = document.querySelector('.biens-vendus__wall');
const windowWidth = window.innerWidth;

const gridBiensVendus = new Masonry(wallBiensVendus, {
  columnWidth: '.biens-vendus__item',
  itemSelector: '.biens-vendus__item',
  gutter: 16,
  fitWidth: true,

  containerStyle: {
    position: 'relative',
    width: '100%',
  },
});
